import { updateConditionNameAction } from 'editor/src/store/design/slice';
import { ConditionAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const updateConditionNameOperation = (address: ConditionAddress, name: string) => (dispatch: ThunkDispatch) => {
  dispatch(updateConditionNameAction({ address, name }));
};

export default updateConditionNameOperation;
